<div class="preview">
  @if (activeSlot()) {
    <div class="preview__stage">
      <!-- Quem rola é este contêiner quando o documento avisa a altura (o iframe sem same-origin não deixa ler a
           rolagem de dentro). O segundo iframe é o rascunho novo carregando escondido; o `track` pelo id mantém o
           mesmo elemento quando ele é promovido, então não recarrega. -->
      <div #scroller class="preview__scroller">
        @for (slot of slots(); track slot.id; let current = $first) {
          <iframe
            class="preview__frame"
            [class.preview__frame--incoming]="!current"
            [style.height.px]="slot.height"
            [attr.data-slot]="slot.id"
            [attr.aria-hidden]="current ? null : 'true'"
            [attr.tabindex]="current ? null : -1"
            sandbox="allow-scripts"
            referrerpolicy="no-referrer"
            [title]="'Visualização da versão ' + (versionNumber() ?? '') + ' do briefing'"
            [srcdoc]="slot.html"></iframe>
        }
      </div>

      @if (view().status === 'loading' || slots().length > 1) {
        <span class="preview__badge" role="status">
          <i class="pi pi-sync" aria-hidden="true"></i>
          Atualizando o rascunho
        </span>
      } @else if (view().status === 'error') {
        <div class="preview__banner" role="alert">
          <span>{{ errorMessage() }}</span>
          <button type="button" class="preview__banner-action" (click)="retry.emit()">
            Tentar de novo
          </button>
        </div>
      }
    </div>
  } @else if (view().status === 'error') {
    <div class="preview__state" role="alert">
      <span class="preview__state-icon preview__state-icon--error" aria-hidden="true"
        ><i class="pi pi-exclamation-triangle"></i
      ></span>
      <p class="preview__state-title">A visualização não abriu</p>
      <p class="preview__state-text">{{ errorMessage() }}</p>
      <app-button
        [label]="'Tentar de novo'"
        [icon]="'refresh'"
        [theme]="'white'"
        [noMargin]="true"
        (sendButtonClick)="retry.emit()" />
    </div>
  } @else {
    <!-- Esqueleto de página: sem rascunho ainda (em geração ou 404) ou carregando a primeira vez. -->
    <div class="preview__stage preview__stage--skeleton" role="status">
      <div class="sheet" aria-hidden="true">
        <span class="sheet__bar sheet__bar--title"></span>
        <span class="sheet__bar sheet__bar--subtitle"></span>
        <span class="sheet__block"></span>
        <div class="sheet__cards"><span></span><span></span><span></span></div>
        <span class="sheet__bar"></span>
        <span class="sheet__bar"></span>
        <span class="sheet__bar sheet__bar--short"></span>
      </div>
      <p class="preview__skeleton-text">
        @if (generating()) {
          <app-cog-loading-spinner [size]="20" />
          O agente está montando o primeiro rascunho
        } @else if (view().status === 'waiting') {
          {{
            view().message ||
              'Esta versão não tem visualização na tela. Use Baixar PDF, no ícone da barra da versão.'
          }}
        } @else {
          <app-cog-loading-spinner [size]="20" />
          Carregando a visualização
        }
      </p>
    </div>
  }
</div>
